// extracted by mini-css-extract-plugin
export var rightPanelOpenOld = "_98-0";